<template>
  <div>
    <div class="row" style="margin-bottom: 76px" ref="content">
      <div class="col-md-12 fme-content">
        <div class="container-fluid" v-if="selectVisible === true" >
          <div class="row fme-list-home__title fme-montserrat-font">
            <div class="col-md-2">
              <h1 class="" >{{ $t('supervision.metric.pageTitle') }}</h1>
            </div>
          </div>

          <div class="row fme-overview-menu">
            <div class="col-md-4 fme-overview-select">
              <BaseSelect selectId="select-regions" :selectValues="selectRegions" selectCss="fm-select-group__title--not--margin" :selectCurrentValue="regionId" @returnedSelectValue="regionSelect('region', $event)" :selectTranslate="false" :selectTitle="$t('supervision.metric.select.region.title')" class="fme-metric-inputs__title" />
            </div>

            <div class="col-md-4">
              <BaseInputAutocomplete :inputCurrentValue="locationName" :inputTitle="$t('supervision.metric.input.location.title')" :inputPlaceholder="$t('supervision.metric.input.location.placeholder_optional')" :inputUrl="locationAutocompleteUrl" inputId="input-location-name" @returned-input-autocomplete-value="inputValue('location', $event)" :inputErrorText="$t(metricError.locationName)" class="fme-metric-inputs__title" :inputDisabled="!hasRegion" />
            </div>

            <div class="col-md-4">
              <BaseInputAutocomplete :inputCurrentValue="employeeName" :inputTitle="$t('supervision.metric.input.employee.title')" :inputPlaceholder="$t('supervision.metric.input.employee.placeholder_optional')" :inputUrl="employeeAutocompleteUrl" inputId="input-employee-name" @returned-input-autocomplete-value="inputValue('employee', $event)" :inputErrorText="$t(metricError.employeeName)" class="fme-metric-inputs__title" :inputDisabled="!hasRegion" />
            </div>
          </div>

          <div class="row fme-metric-inputs fme-metric-inputs__one">
            <div class="col-md-2 fme-metric-inputs__period">
              <BaseInput :inputCurrentValue="startPeriodValue" :inputTitle="$t('supervision.report.input.period.start')" inputPlaceholder="$t('supervision.report.input.period.title')" inputType="date" inputCss="" inputId="input-start-period" @returned-input-value="inputValue('startPeriod', $event)" :inputErrorText="$t(metricError.startPeriod)" class="fme-metric-inputs__title" :inputDisabled="!hasRegion" />
            </div>

            <div class="col-md-2 fme-metric-inputs__period">
              <BaseInput :inputCurrentValue="endPeriodValue" :inputTitle="$t('supervision.report.input.period.finish')" inputPlaceholder="$t('supervision.report.input.period.title')" inputType="date" inputCss="" inputId="input-end-period" @returned-input-value="inputValue('endPeriod', $event)" :inputErrorText="$t(metricError.endPeriod)" class="fme-metric-inputs__title" :inputDisabled="!hasRegion" />
            </div>
          </div>

          <div class="row fme-metric-inputs">
            <div class="col-md-1 fme-metric-inputs__button">
              <a v-if="hasRegionPeriod === false" class="btn fme-btn fme-btn-secondary text-white" >
                {{ calcButtonTitle }}
              </a>
              <a v-else @click.prevent="searchInfos" class="btn fme-btn fme-btn-primary text-white">
                {{ calcButtonTitle }}
              </a>
            </div>
          </div>

          <div v-if="cardsVisible" class="row fme-metric-cards">
            <div class="col-md-12">
              <div class="row fme-metric-cards__row--text">
                <div class="col-md-10 fme-metric-cards__title">
                  <h2 class="fme-metric-cards__title--region">{{regionName}}</h2>
                  <p class="fme-metric-cards__title--subtitle">{{ startPeriodValue | formatDate }} - {{ endPeriodValue | formatDate }}</p>
                </div>

                <div class="col-md-2 fme-metric-inputs__button">
                  <a @click.prevent="exportXLS" class="btn fme-btn fme-btn-secondary text-white" >
                    {{ exportXLSButtonTitle }}
                  </a>
                </div>

                <div class="col-md-6 fme-metric-cards__actions">
                  <button class="btn fme-btn fme-btn-secondary d-none">
                    <font-awesome-icon fas icon="reply" class="" /> {{ $t('supervision.crud.button.goBack') }}
                  </button>

                  <button class="btn fme-btn fme-btn-primary d-none" @click="download(pdfConfig)">
                    <font-awesome-icon fas icon="share-alt" class="" /> {{ $t('supervision.crud.button.share') }}
                  </button>
                </div>
              </div>

              <div class="row fme-metric-cards__row--cards">
                <div class="col-md-12">
                  <CrudLargeCardNavigation :items="cardsMetrics" />
                </div>
                <div class="col-md-12">
                  <TableJourneyMetricsData :items="cardsJourneys" />
                </div>
              </div>
            </div>
          </div>

          <div v-if="cardsVisible" class="row fme-metric-list d-none">
            <div v-if="efficiencyValue.efficiency > 0" class="col-md-12">
              <router-view/>
            </div>
            <div v-else class="col-md-12" style="margin-top: 20px;">
              <p>{{ $t('supervision.metric.message.metricsNotFound') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import axios from 'axios'
import moment from 'moment'
import xls from '@/utils/xlsMetrics'

const BaseInput = () => import('@/components/fragment/input/BaseInput')
const BaseInputAutocomplete = () => import('@/components/fragment/input/BaseInputAutocomplete')
const BaseSelect = () => import('@/components/fragment/select/BaseSelect')
const CrudLargeCardNavigation = () => import('@/components/fragment/card/CrudLargeCardNavigation')
const TableJourneyMetricsData = () => import('@/components/fragment/table/TableJourneyMetricsData')

export default {
  name: 'MetricHomePage',
  created () {
    this.changeCrudPage(false)
    this.changeVisitsPageOverview(false)
    this.changeMetricPage(true)
    this.changeReportPage(false)
    this.getRegions()
  },
  mounted () {
  },
  updated () {
    this.changeMetricPage(true)
  },
  beforeDestroy () {
    this.clearMetric()
    this.changeMetricPage(false)
    this.changeErrors([])
  },
  data () {
    return {
      regionsUrl: `${process.env.VUE_APP_REGIONS_API}?fields=id,name&status=active`,
      regionUrl: process.env.VUE_APP_REGIONS_API,
      selectVisible: false,
      cardsVisible: false,
      hasRegion: false,
      hasClient: false,
      hasLocation: false,
      hasRoute: false,
      hasEmployee: false,
      hasStartPeriod: false,
      hasEndPeriod: false,
      hasRegionPeriod: false,
      hasSearch: false,
      calcButtonTitle: 'Calcular',
      exportXLSButtonTitle: 'Exportar XLS',
      efficiencyPercent: {
        percent: 0,
        done: 0,
        items: []
      },
      journeys: [],
      averageTime: '',
      checklistNotInAccordance: {
        percent: 0,
        notInAccordance: 0,
        total: 0
      },
      selectRegions: {
        'default': 'supervision.metric.select.region.default',
        'options': []
      },
      metricError: {
        'route': '',
        'client': '',
        'location': '',
        'employee': '',
        'period': ''
      },
      routeAutocompleteUrl: `${process.env.VUE_APP_ROUTES_API}?fields=id,name&status=active&filters=name.lk.`,
      clientAutocompleteUrl: `${process.env.VUE_APP_CLIENTS_API}?fields=id,name&status=active&filters=name.lk.`,
      locationAutocompleteUrl: `${process.env.VUE_APP_LOCATIONS_API}?fields=id,name,uuid&status=active&filters=name.lk.`,
      employeeAutocompleteUrl: `${process.env.VUE_APP_USERS_API}?fields=id,name,uuid&status=active&filters=name.lk.`,
      metricUrl: `${process.env.VUE_APP_REPORT_METRIC_API}`,
      checklistsMetricsUrl: `${process.env.VUE_APP_REPORT_CHECKLISTS_METRIC_API}`
    }
  },
  props: {
  },
  components: {
    BaseSelect,
    BaseInput,
    BaseInputAutocomplete,
    CrudLargeCardNavigation,
    TableJourneyMetricsData
  },
  computed: {
    ...mapGetters(['axiosHeaders1']),
    ...mapGetters('ModuleErrors', [
      'errorsList'
    ]),
    ...mapGetters('ModuleMetric', [
      'efficiencyMetric'
    ]),
    ...mapGetters('ModuleMetric', [
      'regionsMetric',
      'regionIdMetric',
      'regionNameMetric',
      'regionUuidMetric',
      'routeIdMetric',
      'routeNameMetric',
      'clientIdMetric',
      'clientNameMetric',
      'locationIdMetric',
      'locationNameMetric',
      'locationUuidMetric',
      'employeeIdMetric',
      'employeeNameMetric',
      'employeeUuidMetric',
      'startPeriodMetric',
      'endPeriodMetric'
    ]),
    regions () {
      return this.regionsMetric
    },
    regionId () {
      return this.regionIdMetric
    },
    regionName () {
      return this.regionNameMetric
    },
    regionUuid () {
      return this.regionUuidMetric
    },
    routeId () {
      return this.routeIdMetric
    },
    routeName () {
      return this.routeNameMetric
    },
    clientId () {
      return this.clientIdMetric
    },
    clientName () {
      return this.clientNameMetric
    },
    locationId () {
      return this.locationIdMetric
    },
    locationName () {
      return this.locationNameMetric
    },
    locationUuid () {
      return this.locationUuidMetric
    },
    employeeId () {
      return this.employeeIdMetric
    },
    employeeName () {
      return this.employeeNameMetric
    },
    employeeUuid () {
      return this.employeeUuidMetric
    },
    startPeriodValue () {
      return this.startPeriodMetric
    },
    endPeriodValue () {
      return this.endPeriodMetric
    },
    efficiencyValue () {
      return this.efficiencyMetric
    },
    cardsMetrics () {
      let items = [
        {
          'title': 'supervision.metric.card.visitEfficiency',
          'route': 'MetricVisitEfficiencyPage',
          'number': 0,
          'type': 'small',
          'infoType': 'percent',
          'percent': this.efficiencyPercent.percent > 0 ? parseInt(this.efficiencyPercent.percent, 10) : 0,
          'quantityNumber': 0,
          'quantityString': '',
          'quantityText': '',
          'topItems': [],
          'hasItems': false
        },
        {
          'title': 'supervision.metric.card.visitAverageTime',
          'route': 'MetricVisitEfficiencyPage',
          'number': 0,
          'type': 'small',
          'infoType': 'string',
          'percent': 0,
          'quantityNumber': 0,
          'quantityString': this.applyDurationFormat(this.averageTime)[0],
          'quantityText': this.applyDurationFormat(this.averageTime)[1],
          'topItems': [],
          'hasItems': false
        },
        /*
        , {
          'title': 'supervision.metric.card.visitOccurrences',
          'route': 'MetricVisitOccurrencesPage',
          'number': this.deviceNumber,
          'type': 'small',
          'infoType': 'quantity',
          'percent': 0,
          'quantityNumber': 89,
          'quantityString': '',
          'quantityText': 'Eventos',
          'topItems': [
            { 'text': 'LOJAS AMERICANAS', 'number': 14 },
            { 'text': 'MARABRAZ', 'number': 14 },
            { 'text': 'PERNAMBUCANAS', 'number': 14 }
          ],
          'hasItems': true
        },
        {
          'title': 'supervision.metric.card.typesOccurrences',
          'route': 'MetricTypesOccurrencesPage',
          'number': this.checklistNumber,
          'type': 'small',
          'infoType': 'quantity',
          'percent': 0,
          'quantityNumber': 12,
          'quantityString': '',
          'quantityText': 'Vandalismo',
          'topItems': [
            { 'text': 'Lojas Americanas', 'number': 4 },
            { 'text': 'Marabraz', 'number': 3 },
            { 'text': 'Pernambucanas', 'number': 3 }
          ],
          'hasItems': true
        },
        */
        {
          'title': 'supervision.metric.card.nonconformingChecklist',
          'route': 'MetricNonconformingChecklistPage',
          'number': 0,
          'type': 'small',
          'infoType': 'string',
          'percent': 0,
          'quantityNumber': 0,
          'quantityString': this.checklistNotInAccordance.percent > 0 ? this.checklistNotInAccordance.percent.toFixed(2).replace('.', ',') + "%" : "0%",
          'quantityText': '',
          'topItems': [],
          'hasItems': false
        }
      ]
      return items
    },
    cardsJourneys () {
      let items = this.journeys.map(i => {
        return {
          'id': i.journey_id,
          'name': i.journey_name,
          'period': i.period,
          'startDate': i.start_date,
          'endDate': i.end_date,
          'efficiency': i.efficiency,
          'done': i.done,
          'total': i.total,
          'averageTime': i.average_time,
          'regionUuid': this.regionUuid,
          'startPeriod': moment(this.startPeriodValue).format('YYYY-MM-DD'),
          'endPeriod': moment(this.endPeriodValue).format('YYYY-MM-DD'),
          'locationUuid': this.locationUuid,
          'employeeUuid': this.employeeUuid,
          'journeyUuid': i.journey_uuid
        }
      })
      return items
    }
  },
  methods: {
    ...mapActions('ModuleMetric', [
      'changeMetricPage',
      'changeRegionsMetric',
      'clearRegionsMetric',
      'changeRegionIdMetric',
      'changeRegionUuidMetric',
      'changeRegionNameMetric',
      'clearRegionMetric',
      'changeRouteIdMetric',
      'changeRouteNameMetric',
      'changeClientIdMetric',
      'changeClientNameMetric',
      'changeLocationIdMetric',
      'changeLocationNameMetric',
      'changeLocationUuidMetric',
      'changeEmployeeIdMetric',
      'changeEmployeeNameMetric',
      'changeEmployeeUuidMetric',
      'changeStartPeriodMetric',
      'changeEndPeriodMetric',
      'changeEfficiencyMetric',
      'changeChecklistNotInAccordanceMetric'
    ]),
    ...mapActions('ModuleErrors', [
      'changeErrors'
    ]),
    ...mapActions('ModuleOverview', [
      'changeVisitsPageOverview'
    ]),
    ...mapActions('ModuleSupervision', [
      'changeCrudPage'
    ]),
    ...mapActions('ModuleReport', [
      'changeReportPage'
    ]),
    getRegions () {
      this.clearRegionsMetric([])
      this.clearRegionMetric()

      axios.get(this.regionsUrl, {
        headers: this.axiosHeaders1
      })
        .then(response => {
          let regions = response.data.data
          let newRegions = []

          regions.forEach((value, index, array) => {
            let newObj = {
              'name': value.id,
              'value': value.name
            }

            newRegions.push(newObj)
          })

          this.selectRegions.options = newRegions
          this.selectVisible = true
        })
        .catch(e => {
          if (e.response.status && e.response.status === 401) {
            this.logoutUser()
          } else {
            console.log(e)
          }
        })
    },
    async regionSelect (refValue, event) {
      if (refValue === 'region') {
        this.clearMetric()
        this.hasSearch = false
        this.changeEfficiencyMetric({})
        this.changeChecklistNotInAccordanceMetric({})
        if (this.cardsVisible === true) {
          this.cardsVisible = false
        }

        await axios.get(`${this.regionUrl}/${event}`, {
          headers: this.axiosHeaders1
        })
          .then(response => {
            return response.data.data
          })
          .then(region => {
            this.changeRegionIdMetric(region.id)
            this.changeRegionNameMetric(region.name)
            this.changeRegionUuidMetric(region.uuid)

            this.hasRegion = true
            this.hasClient = false
            this.hasLocation = false
            this.hasRoute = false
            this.hasEmployee = false
            this.hasStartPeriod = false
            this.hasEndPeriod = false
            this.hasRegionPeriod = false

            if (this.hasRegion === true && this.hasStartPeriod === true && this.hasEndPeriod === true) {
              this.hasRegionPeriod = true
            }

            return region.id
          })
      }
    },
    inputValue (refValue, eventValue) {
      if (refValue === 'route') {
        if (this.hasClient === true || this.hasLocation === true || this.hasEmployee === true) {
          this.changeClientIdMetric(null)
          this.changeClientNameMetric('')
          this.changeLocationIdMetric(null)
          this.changeLocationNameMetric('')
          this.changeLocationUuidMetric('')
          this.changeEmployeeIdMetric(null)
          this.changeEmployeeNameMetric('')
          this.changeEmployeeUuidMetric('')
        }

        if (eventValue === '') {
          this.hasRoute = false
          this.changeRouteIdMetric(null)
          this.changeRouteNameMetric('')
        } else {
          this.hasRoute = true
          this.changeRouteIdMetric(eventValue.id)
          this.changeRouteNameMetric(eventValue.name)
        }

        this.hasClient = false
        this.hasLocation = false
        this.hasEmployee = false
      } else if (refValue === 'client') {
        if (this.hasRoute === true || this.hasLocation === true || this.hasEmployee === true) {
          this.changeRouteIdMetric(null)
          this.changeRouteNameMetric('')
          this.changeLocationIdMetric(null)
          this.changeLocationNameMetric('')
          this.changeLocationUuidMetric('')
          this.changeEmployeeIdMetric(null)
          this.changeEmployeeNameMetric('')
          this.changeEmployeeUuidMetric('')
        }

        if (eventValue === '') {
          this.hasClient = false
          this.changeClientIdMetric(null)
          this.changeClientNameMetric('')
        } else {
          this.hasClient = true
          this.changeClientIdMetric(eventValue.id)
          this.changeClientNameMetric(eventValue.name)
        }

        this.hasRoute = false
        this.hasLocation = false
        this.hasEmployee = false
      } else if (refValue === 'location') {
        if (this.hasRoute === true || this.hasClient === true || this.hasEmployee === true) {
          this.changeRouteIdMetric(null)
          this.changeRouteNameMetric('')
          this.changeClientIdMetric(null)
          this.changeClientNameMetric('')
          this.changeEmployeeIdMetric(null)
          this.changeEmployeeNameMetric('')
          this.changeEmployeeUuidMetric('')
        }

        if (eventValue === '') {
          this.hasLocation = false
          this.changeLocationIdMetric(null)
          this.changeLocationNameMetric('')
          this.changeLocationUuidMetric('')
        } else {
          this.hasLocation = true
          this.changeLocationIdMetric(eventValue.id)
          this.changeLocationNameMetric(eventValue.name)
          this.changeLocationUuidMetric(eventValue.uuid)
        }

        this.hasRoute = false
        this.hasClient = false
        this.hasEmployee = false
      } else if (refValue === 'employee') {
        if (this.hasRoute === true || this.hasClient === true || this.hasLocation === true) {
          this.changeRouteIdMetric(null)
          this.changeRouteNameMetric('')
          this.changeClientIdMetric(null)
          this.changeClientNameMetric('')
          this.changeLocationIdMetric(null)
          this.changeLocationNameMetric('')
          this.changeLocationUuidMetric('')
        }

        if (eventValue === '') {
          this.hasEmployee = false
          this.changeEmployeeIdMetric(null)
          this.changeEmployeeNameMetric('')
          this.changeEmployeeUuidMetric('')
        } else {
          this.hasEmployee = true
          this.changeEmployeeIdMetric(eventValue.id)
          this.changeEmployeeNameMetric(eventValue.name)
          this.changeEmployeeUuidMetric(eventValue.uuid)
        }

        this.hasRoute = false
        this.hasClient = false
        this.hasLocation = false
      } else if (refValue === 'startPeriod') {
        this.changeStartPeriodMetric(eventValue)

        if (eventValue !== '') {
          this.hasStartPeriod = true
        } else {
          this.hasStartPeriod = false
        }

        if (this.hasRegion === true && this.hasStartPeriod === true && this.hasEndPeriod === true) {
          this.hasRegionPeriod = true
        } else {
          this.hasRegionPeriod = false
        }
      } else if (refValue === 'endPeriod') {
        this.changeEndPeriodMetric(eventValue)

        if (eventValue !== '') {
          this.hasEndPeriod = true
        } else {
          this.hasEndPeriod = false
        }

        if (this.hasRegion === true && this.hasStartPeriod === true && this.hasEndPeriod === true) {
          this.hasRegionPeriod = true
        } else {
          this.hasRegionPeriod = false
        }
      }
    },
    searchInfos () {
      this.calcButtonTitle = 'Calculando...'

      // fetching visit metrics

      let url = `${this.metricUrl}`
      let startPeriod = moment(this.startPeriodValue).format('YYYY-MM-DD')
      let endPeriod = moment(this.endPeriodValue).format('YYYY-MM-DD')
      let region = this.regionId
      let regionUuid = this.regionUuid
      let route = this.routeId
      let client = this.clientId
      let location = this.locationId
      let locationUuid = this.locationUuid
      let employee = this.employeeId
      let employeeUuid = this.employeeUuid

      let newUrl = ''
      if (!this.hasRoute && !this.hasClient && !this.hasLocation && !this.hasEmployee) {
        newUrl = `${url}/${region}/${startPeriod}T00:00:00Z/${endPeriod}T23:59:59.999Z`
      } else if (this.hasRoute) {
        newUrl = `${url}/${region}/${startPeriod}T00:00:00Z/${endPeriod}T23:59:59.999Z?metric=itinerary&scope=itinerary.eq.${route}`
      } else if (this.hasClient) {
        newUrl = `${url}/${region}/${startPeriod}T00:00:00Z/${endPeriod}T23:59:59.999Z?metric=client&scope=client.eq.${client}`
      } else if (this.hasLocation) {
        newUrl = `${url}/${region}/${startPeriod}T00:00:00Z/${endPeriod}T23:59:59.999Z?metric=location&scope=location.eq.${location}`
      } else if (this.hasEmployee) {
        newUrl = `${url}/${region}/${startPeriod}T00:00:00Z/${endPeriod}T23:59:59.999Z?metric=supervisor_region&scope=supervisor.eq.${employee}`
      }

      axios.get(newUrl, {
        headers: this.axiosHeaders1
      })
        .then(response => {
          return response.data.data
        })
        .then(metric => {
          this.efficiencyPercent.percent = metric.efficiency
          this.efficiencyPercent.done = metric.done
          this.efficiencyPercent.items = metric.kinds
          this.averageTime = metric.average_time
          this.journeys = metric.journeys || []
          this.changeEfficiencyMetric(metric)

          this.cardsVisible = true
          this.hasSearch = true

          this.calcButtonTitle = 'Calcular'

          const element = document.getElementsByClassName('fme-metric-cards')[0]
          const y = element.getBoundingClientRect().top
          window.scrollTo({top: y, behavior: 'smooth'})
        })
        .catch(e => {
          if (e.response.status && e.response.status === 401) {
            this.logoutUser()
          } else {
            console.log(e)
          }
        })

      // fetching checklist metrics

      let checklistsMetricsUrl = `${this.checklistsMetricsUrl}/${regionUuid}/${startPeriod}T00:00:00Z/${endPeriod}T23:59:59.999Z`
      if (this.hasLocation) {
        checklistsMetricsUrl = `${checklistsMetricsUrl}?filters=location-uuid.eq.${locationUuid}`
      } else if (this.hasEmployee) {
        checklistsMetricsUrl = `${checklistsMetricsUrl}?filters=user-uuid.eq.${employeeUuid}`
      }

      axios.get(checklistsMetricsUrl, {
        headers: this.axiosHeaders1
      })
      .then(response => {
        return response.data.data
      })
      .then(metrics => {
        let notInAccordance = 0
        let total = 0
        metrics.forEach((metric) => {
          if (metric.status === "NOT_IN_ACCORDANCE") notInAccordance += metric.count
          total += metric.count
        })
        let percent = notInAccordance * 1.0 / Math.max(total, 1) * 100

        this.checklistNotInAccordance.percent = percent
        this.checklistNotInAccordance.notInAccordance = notInAccordance
        this.checklistNotInAccordance.total = total
        this.changeChecklistNotInAccordanceMetric(this.checklistNotInAccordance)
      })
      .catch(e => {
        if (e.response.status && e.response.status === 401) {
          this.logoutUser()
        } else {
          console.log(e)
        }
      })
    },
    clearSearch () {
      this.cardsVisible = false
      this.hasSearch = false
      this.changeEfficiencyMetric({})
      this.changeChecklistNotInAccordanceMetric({})
      this.$router.push({ name: 'metricHomePage' })
    },
    clearMetric () {
      this.changeRegionIdMetric(null)
      this.changeRegionNameMetric('')
      this.changeRegionUuidMetric('')
      this.changeRouteIdMetric(null)
      this.changeRouteNameMetric('')
      this.changeClientIdMetric(null)
      this.changeClientNameMetric('')
      this.changeLocationIdMetric(null)
      this.changeLocationNameMetric('')
      this.changeLocationUuidMetric('')
      this.changeEmployeeIdMetric(null)
      this.changeEmployeeNameMetric('')
      this.changeEmployeeUuidMetric('')
      this.changeStartPeriodMetric('')
      this.changeEndPeriodMetric('')
      this.changeEfficiencyMetric({})
      this.changeChecklistNotInAccordanceMetric({})
    },
    applyDurationFormat (duration) {
      if (!duration) return ['-', '']
      const value = duration.split(':')
      const result = (value[0] === '00' ? (value[1] === '00' ? [parseInt(value[2]), 'segundos'] : [parseInt(value[1]), 'minutos']) : [parseInt(value[0]), 'horas'])
      if (result[0] === 1) result[1] = result[1].slice(0, -1)
      if (result[1].substr(0, 1) === 'h') result[0] = `${result[0]}:${value[1]}`
      return result
    },
    exportXLS () {
      xls({
        regionName: this.regionName,
        startPeriodValue: this.startPeriodValue,
        endPeriodValue: this.endPeriodValue,
        locationName: this.locationName,
        supervisorName: this.employeeName,
        efficiencyPercent: this.efficiencyPercent.percent,
        averageTime: this.averageTime
      },
      this.journeys,
      this)
    }
  },
  filters: {
    formatDate (value) {
      let newValue = moment(value).format('DD/MM/YYYY')
      return newValue
    }
  },
  watch: {
    errorsList () {
      this.metricError.routeName = ''
      this.metricError.clientName = ''
      this.metricError.locationName = ''
      this.metricError.employeeName = ''
      this.metricError.period = ''

      if (this.hasProperty(this.errorsList.errors, 'route')) {
        this.metricError.routeName = `errors.route.${this.errorsList.errors.route[0].keyword}`
      }

      if (this.hasProperty(this.errorsList.errors, 'client')) {
        this.metricError.clientName = `errors.clientId.${this.errorsList.errors.client[0].keyword}`
      }

      if (this.hasProperty(this.errorsList.errors, 'location')) {
        this.metricError.locationName = `errors.location.${this.errorsList.errors.location[0].keyword}`
      }

      if (this.hasProperty(this.errorsList.errors, 'employee')) {
        this.metricError.employeeName = `errors.employee.${this.errorsList.errors.employee[0].keyword}`
      }

      if (this.hasProperty(this.errorsList.errors, 'period')) {
        this.metricError.period = `errors.period.${this.errorsList.errors.period[0].keyword}`
      }
    }
  }
}
</script>

<style lang="scss">
.fme-list-home__title {
  padding-left: 12px;
  padding-bottom: 25px;
  h1 {
    font-size: 24px;
    font-weight: 800;
    line-height: 34px;
    text-transform: uppercase;
    color: $fme-color__space-cadet;
  }
}
.fme-overview-menu{
  .fme-overview-select {
    .fm-select-group__title {
      h5 {
        font-family: 'Montserrat', sans-serif;
        font-weight: 800;
        color: $fme-color__dark-silver;
      }
    }
  }
  .fme-overview-clear {
    font-size: 13px;
    font-weight: 700;
    padding-top: 50px;
    text-transform: uppercase;
    color: $fme-color__yale-blue;
    a {
      &:hover {
        color: $fme-color__celestial-blue;
        cursor: pointer;
      }
    }
  }
  .fme-metric-inputs__title {
    .fm-input-group__title {
      h5 {
        font-family: 'Montserrat', sans-serif;
        font-weight: 800;
        color: $fme-color__dark-silver;
      }
    }
  }
}
.fme-metric-inputs {
  &.fme-metric-inputs__one {
    margin-top: 45px;
  }
  &.fme-metric-inputs__two {
    margin-top: 0px;
  }
  height: 105px;
  .fme-metric-inputs__title {
    .fm-input-group__title {
      h5 {
        font-family: 'Montserrat', sans-serif;
        font-weight: 800;
        color: $fme-color__dark-silver;
      }
    }
  }
  .fme-metric-inputs__button {
    padding-top: 32px;
    a {
      &:disabled {
        color: $fme-color__write;
        background: $fme-color__pewter-blue;
        &:hover {
          color: $fme-color__write;
          background: $fme-color__pewter-blue;
        }
      }
    }
  }
}
.fme-metric-cards {
  .fme-metric-cards__row--text {
    margin-top: 60px;
    margin-bottom: 25px;
    .fme-metric-cards__title {
      .fme-metric-cards__title--region {
        font-family: 'Montserrat', sans-serif;
        font-size: 36px;
        font-weight: 800;
        color: $fme-color__space-cadet;
        margin-bottom: 9px;
      }
      .fme-metric-cards__title--subtitle {
        font-family: 'Hind', sans-serif;
        font-size: 18px;
        font-weight: 300;
        color: $fme-color__yale-blue;
        margin-bottom: 0;
      }
    }
    .fme-metric-cards__actions {
      padding-top: 6px;
      text-align: right;
      .fme-metric-cards__actions--period {
        display: inline-block;
        font-family: 'Hind', sans-serif;
        font-size: 24px;
        font-weight: 300;
        color: $fme-color__yale-blue;
      }
      .btn {
        &.fme-btn-secondary {
          margin-left: 22px;
          margin-right: 22px;
        }
      }
    }
  }
}
</style>
